module.exports = __webpack_public_path__ + "img/menu21.792a8e04.png";